import React from "react"

const GlobalStateContext = React.createContext()

export default GlobalStateContext